export default function VPNServiceSection() {
  const services = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide to ensure maximum privacy and security.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Connect to our worldwide network of high-speed servers strategically located across multiple countries for optimal performance and unrestricted access.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Ultra-Fast Connection',
      description: 'Experience blazing-fast speeds with our optimized protocols and zero bandwidth throttling. Stream, download, and browse without any limitations.'
    }
  ];

  return (
    <section id="vpn-service" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-4">
          <span className="inline-block px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-semibold">
            Our Solution
          </span>
        </div>

        <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-20">
          Professional VPN<br />
          Service for Everyone
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 group border border-gray-100 hover:border-teal-500"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-2xl mb-6 group-hover:bg-teal-500 transition-colors">
                <i className={`${service.icon} text-3xl text-teal-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}